/**
 * Finds selected packages from studioCreativesData based on bookingData.creativePackages
 * @param {Array} studioCreativesData - Array of StudioCreative objects with creative.packages.items
 * @param {Array} creativePackages - Array of booked packages with creativeId and packageId
 * @returns {Array} Array of package objects with full package details and booking info
 */
export const getSelectedPackages = (studioCreativesData, creativePackages) => {
  if (!studioCreativesData || !Array.isArray(studioCreativesData) || 
      !creativePackages || !Array.isArray(creativePackages) || creativePackages.length === 0) {
    return [];
  }

  return creativePackages
    .map((bookedPkg) => {
      // Ensure we have the required IDs
      if (!bookedPkg?.creativeId || !bookedPkg?.packageId) {
        return null;
      }

      // Find the creative in studioCreativesData by matching creativeId
      const studioCreative = studioCreativesData.find(
        (sc) => sc?.creative?.id === bookedPkg.creativeId
      );

      if (!studioCreative) {
        return null;
      }

      // Check if creative has packages
      if (!studioCreative.creative?.packages?.items || !Array.isArray(studioCreative.creative.packages.items)) {
        return null;
      }

      // Find the package in the creative's packages.items array by matching packageId
      const packageData = studioCreative.creative.packages.items.find(
        (pkg) => pkg?.id === bookedPkg.packageId
      );

      if (!packageData) {
        return null;
      }

      return {
        ...packageData,
        creativeId: bookedPkg.creativeId,
        creativeName: studioCreative.creative.displayName,
        bookedPackageData: bookedPkg,
      };
    })
    .filter(Boolean);
};

